import { Form } from "antd";
import React from "react";
import Input from "./BaseInput";
import ShopType from "@/enum/ShopType";

interface ConsigneeStreetFieldProps {
    shopType: ShopType;
}

const hideConsigneeStreetShopTypes = [
    ShopType.PDD_FDS,
    ShopType.ALIBABA_SUPPLIER,
    ShopType.DOUDIAN_SUPPLIER,
    ShopType.YOUZAN,
];

const ConsigneeStreetField: React.FC<ConsigneeStreetFieldProps> = function (props) {
    const { shopType } = props;

    if (hideConsigneeStreetShopTypes.includes(shopType)) return null;

    return (
        <Form.Item label={<span className="search-field-label">收货街道</span>} name="street">
            <Input />
        </Form.Item>
    );
};

export default React.memo(ConsigneeStreetField);
